import React from 'react';

function Footer() {
  return (
    <div className="flex justify-center items-end content-center">
      <span className="text-xs">
        Icons made by Smashicons from www.flaticon.com
      </span>
    </div>
  );
}

export default Footer;
